/* eslint-disable import/prefer-default-export */
import axiosInstance from '../axios.instance';

export const getLanguageListApi = () => axiosInstance.get('/language');

export const getTranslationsApi = (code = '*') => axiosInstance.get(`/language/translations/${code}`);
